import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from '@/components/v4';

const ModalDelete = ({
    children,
    type,
    name,
    handleClose,
    handleSubmit,
    closeWalkthroughId,
    deleteWalkthroughId,
    isDisabled,
    isLoading,
    isOpen,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    Delete {type}: {name}
                </ModalHeader>
                <ModalBody>{children}</ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={isDisabled}
                        mr={3}
                        variant="outline"
                        onClick={() => handleClose()}
                        data-walkthroughid={closeWalkthroughId}>
                        Close
                    </Button>
                    <Button
                        isDisabled={isDisabled}
                        variant="solid"
                        colorScheme="red"
                        isLoading={isLoading}
                        onClick={() => handleSubmit()}
                        data-walkthroughid={deleteWalkthroughId}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalDelete;
